module.exports = __webpack_public_path__ + "static/media/AB_L31_5.2847eb41.jpg";